module.exports = __webpack_public_path__ + "media/registry-cover_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry-cover_2000.jpg
// module id = 29
// module chunks = 0